/**
 * ビーグル養蜂園｜カートの同時購入ガード
 *
 * イベント予約の商品（オフ会の参加費など）と、ふつうのお買い物商品を
 * 同じカートに入れられないようにします。
 *
 * ・いまカートに何が入っているかを覚えておき、追加ボタンが押された瞬間に判定します
 * ・止めたときは、ボタンのそばにお知らせを出します
 * ・オフ会の申込フォームからは window.BeegleCartGuard を呼んで使います
 *
 * イベント予約かどうかの判定は snippets/beegle-is-event.liquid と同じルールです
 * （商品タイプに「イベント」／配送が必要な商品がオフ）。
 */
(function () {
  var MESSAGE_ON_GOODS_PAGE =
    'いまカートにオフ会のご予約が入っています。ご予約は、ほかの商品と一緒にご購入いただけません。';
  var MESSAGE_ON_EVENT_PAGE =
    'いまカートにお買い物中の商品が入っています。オフ会のご予約は、ほかの商品と一緒にご購入いただけません。';

  var initial = window.BeegleCartState || { hasEvent: false, hasGoods: false };
  var state = { hasEvent: !!initial.hasEvent, hasGoods: !!initial.hasGoods };

  function isEventItem(item) {
    if (!item || item.gift_card) return false;
    if (item.product_type && item.product_type.indexOf('イベント') !== -1) return true;
    return item.requires_shipping === false;
  }

  function applyCart(cart) {
    var hasEvent = false;
    var hasGoods = false;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (isEventItem(items[i])) {
        hasEvent = true;
      } else {
        hasGoods = true;
      }
    }
    state.hasEvent = hasEvent;
    state.hasGoods = hasGoods;
    return state;
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(applyCart)
      .catch(function () {
        return state;
      });
  }

  /**
   * 追加してよいかを返します。
   * @param {boolean} isEvent 追加しようとしているのがイベント予約かどうか
   * @returns {{ok: boolean, reason: string, message: string}}
   */
  function check(isEvent) {
    if (isEvent && state.hasGoods) {
      return { ok: false, reason: 'goods-in-cart', message: MESSAGE_ON_EVENT_PAGE };
    }
    if (!isEvent && state.hasEvent) {
      return { ok: false, reason: 'event-in-cart', message: MESSAGE_ON_GOODS_PAGE };
    }
    return { ok: true, reason: '', message: '' };
  }

  function showNote(container, message) {
    if (!container) return;
    var note = container.querySelector('.beegle-mix-note--js');
    if (!note) {
      note = document.createElement('p');
      note.className = 'beegle-mix-note beegle-mix-note--js';
      note.setAttribute('role', 'status');
      container.insertBefore(note, container.firstChild);
    }
    note.innerHTML = '';
    note.appendChild(document.createTextNode(message + ' '));
    var link = document.createElement('a');
    link.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    link.textContent = 'カートを見る';
    note.appendChild(link);
    note.hidden = false;
  }

  function clearNote(container) {
    if (!container) return;
    var note = container.querySelector('.beegle-mix-note--js');
    if (note) note.remove();
  }

  function onAddAttempt(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var form = target.closest('product-form-component');
    if (!form) return;

    if (event.type === 'click' && !target.closest('button[name="add"], add-to-cart-component button')) {
      return;
    }

    var isEvent = form.dataset.beegleEvent === '1';
    var result = check(isEvent);

    if (result.ok) {
      clearNote(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    showNote(form, result.message);
  }

  document.addEventListener('click', onAddAttempt, true);
  document.addEventListener('submit', onAddAttempt, true);

  document.addEventListener('cart:update', function () {
    refresh();
  });
  document.addEventListener('cart:add', function () {
    refresh();
  });

  window.BeegleCartGuard = {
    state: state,
    check: check,
    refresh: refresh,
    isEventItem: isEventItem,
  };
})();
